import axios from "axios"

const BASE_URL = 'https://portal.ok-television.com'

const getHeaders = () => {
    const getAuthToken = () => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return userData?.tokenResponse?.access_token || null
    }

    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
        'User-Agent': 'oktv-panel-KwhjAsSJAV',
        'X-Oktv-User-Agent': 'oktv-panel-KwhjAsSJAV',
    }
}

class ApiMethods {
    static apiRequest(method, url, body = {}, headers = {}) {
        url = BASE_URL + url
        if (Object.keys(headers).length === 0) {
            headers = getHeaders()
        }

        if (
            Object.keys(headers).length > 0 &&
            headers['Content-Type'] === 'application/json' &&
            body
        ) {
            if (Object.keys(body).length > 0) body = JSON.stringify(body)
            else body = null
        }

        return new Promise((resolve, reject) => {
            fetch(url, {
                method,
                headers,
                body,
            })
                .then((response) => {
                    if (response.ok) {
                        if (response.status === 204) {
                            return true
                        }
                        return response.json()
                    }
                    return response.json().then((error) => {
                        throw error
                    })
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    static get(url, headers = {}) {
        return this.apiRequest('GET', url, null, headers)
    }

    static post(url, body, headers = {}) {
        return this.apiRequest('POST', url, body, headers)
    }

    static async postFile(url, dataImage, headers) {
        url = BASE_URL + url
        const drupalData = await axios({
            method: 'post',
            url: url,
            headers: headers,
            data: dataImage,
        })
        return drupalData
    }

    static put(url, body, headers = {}) {
        return this.apiRequest('PUT', url, body, headers)
    }

    static patch(url, body, headers = {}) {
        return this.apiRequest('PATCH', url, body, headers)
    }

    static delete(url, headers = {}) {
        return this.apiRequest('DELETE', url, null, headers)
    }
}

export default ApiMethods
